//统计分析
const ParkingParkingDayReport = () => import(/*webpackChunkName:'finance'*/"@/page/finance/parkingDataAnalysis/parkingDayReport.vue")
const ParkingParkingMonthReport = () => import(/*webpackChunkName:'finance'*/"@/page/finance/parkingDataAnalysis/parkingMonthReport.vue")
const ParkingGroupDayReport = () => import(/*webpackChunkName:'finance'*/"@/page/finance/parkingDataAnalysis/groupDayReport.vue")
const ParkingGroupMonthReport = () => import(/*webpackChunkName:'finance'*/"@/page/finance/parkingDataAnalysis/groupMonthReport.vue")

const RouteTemp = () => import(/*webpackChunkName:'finance'*/'@/page/commons/routeTemp.vue')

export const parkingAnalysis={
    path: '/main/finance/financeReport',
    name: '车场报表',
    meta: {
        requireAuth: true,

    },
    component: RouteTemp,
    children: [

        {
            path: '/main/finance/parkingDayReport',
            name: '车场日报',
            meta: {
                requireAuth: true,
            },
            component: ParkingParkingDayReport
        }, {
            path: '/main/finance/parkingMonthReport',
            name: '车场月报',
            meta: {
                requireAuth: true,
            },
            component: ParkingParkingMonthReport
        }, {
            path: '/main/finance/groupDayReport',
            name: '集团日报',
            meta: {
                requireAuth: true,
            },
            component: ParkingGroupDayReport
        }, {
            path: '/main/finance/groupMonthReport',
            name: '集团月报',
            meta: {
                requireAuth: true,
            },
            component: ParkingGroupMonthReport
        }]
}